module.exports = "https://la-static.vkplay.ru/promo/newstart/img/location-6.fe7af3d3.jpg";